import React, { useState, useEffect } from 'react'
import {
  TextField, Button, Grid, Typography, Paper, Table, Input, InputAdornment,
  TableBody, TableCell, TableContainer, TableHead,
  TableRow, TablePagination, Select, MenuItem, FormControl, InputLabel, IconButton, Tooltip,
  Box, FormControlLabel, Divider, Autocomplete, FormLabel, RadioGroup, Radio, CircularProgress,
  Alert
} from '@mui/material'
import { SkipNext } from '@mui/icons-material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { es } from 'date-fns/locale'
import { LobService } from '../../services/lobService'
import { formatToCLP } from '../../services/monedaService'
import Swal from 'sweetalert2'
import { PDFDownloadLink } from '@react-pdf/renderer'
import InstallmentPDF from '../InstallmentPDF'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AddIcon from '@mui/icons-material/Add'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setContractFull, setTab, setCuotas } from '../../Redux/TabDucks'
import { countryService } from '../../services/countryService'
import { regionService } from '../../services/regionService'
import { provinceService } from '../../services/provinceService'
import { communeService } from '../../services/communeService'
import { genereService } from '../../services/genereService'
import { tipoClienteService } from '../../services/tipoClienteService'
import { estadoCivilService } from '../../services/estadoCivilService'
import customerService from '../../services/customerService'

import { useJsApiLoader, Autocomplete as GoogleMapsAutocomplete } from '@react-google-maps/api'
import { Checklist } from '@mui/icons-material'
import moment from "moment"; // Importar moment.js
import { ValidarRut, ValidarEmail } from '../../Utilities/ValidarRut';
import { NumericFormat } from 'react-number-format'

const libraries = ['places']

const CuotasForm = () => {
  const dispatch = useDispatch()
  const _TAB = useSelector((store) => store.tab)
  const customer = useSelector((store) => store.tab.customer)
  const customerFull = useSelector((store) => store.tab.customerFormatted)
  const contractFull = useSelector((store) => store.tab.contractFull)
  const cuotasData = useSelector((store) => store.tab.Cuotas)

  const location = useLocation()
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    identifier: '',
    firstName: '',
    numContrato: '',
    observaciones: '',
    fechaContrato: null,
  })

  const [linesOfBusiness, setLinesOfBusiness] = useState([])
  const [installments, setInstallments] = useState({})
  const [paymentData, setPaymentData] = useState({})
  const [pages, setPages] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(6)
  const [metodosPago, setMetodosPago] = useState([])
  const [loading, setLoading] = useState(true)

  //datos de formulario
  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState('')
  const [regiones, setRegiones] = useState([])
  const [selectedRegion, setSelectedRegion] = useState('')
  const [provincias, setProvincias] = useState([])
  const [selectedProvincia, setSelectedProvincia] = useState('')
  const [comunas, setComunas] = useState([])
  const [selectedComuna, setSelectedComuna] = useState('')
  const [tiposCliente, setTipoCliente] = useState([])
  const [selectedTipo, setSelectedTipo] = useState(1)
  const [rutPyme, setRutPyme] = useState('')
  const [nombrePyme, setNombrePyme] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [generos, setGenero] = useState([])
  const [estadoCiviles, setEstadoCivil] = useState([])
  const [estadoCivilList, setEstadoCivilList] = useState([])
  const [autocomplete, setAutocomplete] = useState(null)
  const [direccion, setDireccion] = useState('')
  const [selectedGenero, setSelectedGenero] = useState('')
  const [selectedEstadoCivil, setSelectedEstadoCivil] = useState("")

  const [allowUpdate, setAllowUpdate] = useState(true);
  const [showCuotas, setShowCuotas] = useState(true)
  const [ocupaciones, setOcupaciones] = useState(["Dependiente", "Independiente", "Jubilado", "Cesante", "Estudiante",])

  const [payingCustomer, setPayingCustomer] = useState({
    Identifier: '',
    rut: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    country: '',
    region: '',
    provincia: '',
    tipoCliente: '',
    observations: '',
    pymeData: '',
    genero: '',
    estadoCivil: '',
    rutPyme: '',
    nombrePyme: '',
    ocupacion: ''
  })


  const [finiquitado, setFiniquitado] = useState(false);
  const [cancelado, setCancelado] = useState(false);
  const [bloquearAcciones, setBloquearAcciones] = useState(false);

  useEffect(() => {
    if (_TAB.contractFull?.cancel == true) {
      setCancelado(true)
      setBloquearAcciones(true)
    }
    if (_TAB.contractFull?.finiquitado == true) {
      setFiniquitado(true)
      setBloquearAcciones(true)
    }
  }, [_TAB])



  const fetchCustomer = async () => {

    try {

      var customerData = customerFull.id ? customerFull : await customerService.getCustomerByHubspotIdService(customer.id)

      // Actualizar el estado mapeando las propiedades
      setPayingCustomer({
        Identifier: customerData.rut.replace(/[ .]/g, '') || '',
        rut: customerData.rut.replace(/[ .]/g, '') || '',
        firstName: customerData.firstName || '',
        lastName: customerData.lastName || '',
        email: customerData.email || '',
        phone: customerData.phone || '',
        address: customerData.address || '',
        country: customerData.country || '',
        region: customerData.region || '',
        provincia: customerData.provincia || '',
        comuna: customerData.comuna || '',
        tipoCliente: customerData.tipoClienteSeleccionado || '',
        observations: customerData.observations || '',
        pymeData: customerData.hubspotID || '',
        genero: customerData.genero || '',
        estadoCivil: customerData.estadoCivil || '',
        rutPyme: customerData.rutPyme.replace(/[ .]/g, '') || '', // No se incluye en el objeto original
        nombrePyme: customerData.nombrePyme || '', // No se incluye en el objeto original
        ocupacion: customerData.ocupacion || ''// No se incluye en el objeto original
      })

      setDireccion(customerData.address ?? '')
      setSelectedCountry(customerData.country ?? '')
      setSelectedRegion(customerData.region ?? '')
      setSelectedProvincia(customerData.provincia ?? '')
      setSelectedComuna(customerData.comuna ?? '')
      setSelectedTipo(customerData.tipoClienteSeleccionado ?? 1)
      setSelectedGenero(customerData.genero ?? '')
      setSelectedEstadoCivil(customerData.estadoCivil ?? '')

    } catch (error) {
      console.error('Error al obtener el cliente:', error)
    }
  }

  const cleanCustomer = () => {
    try {
      setPayingCustomer({
        Identifier: '',
        rut: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        country: '',
        region: '',
        provincia: '',
        tipoCliente: '',
        observations: '',
        pymeData: '',
        genero: '',
        estadoCivil: '',
        rutPyme: '',
        nombrePyme: '',
        ocupacion: ''
      })

      setDireccion('')
      setSelectedCountry('')
      setSelectedRegion('')
      setSelectedProvincia('')
      setSelectedComuna('')
      setSelectedTipo(1)
      setSelectedGenero('')
      setSelectedEstadoCivil(1)
    } catch (error) {
    }
  }

  const fetchCountry = async () => {
    try {
      setLoading(true)
      const data = await countryService.getAllCountry()
      setCountries(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchRegion = async () => {
    try {
      setLoading(true)
      const data = await regionService.getAllRegion()
      setRegiones(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchProvincias = async () => {
    try {
      setLoading(true)
      const data = await provinceService.getAllProvinces()
      setProvincias(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchComunas = async (idProvidence) => {
    try {
      setLoading(true)
      const data = await communeService.getAllCommunes()
      setComunas(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchGenero = async () => {
    try {
      setLoading(true)
      const data = await genereService.getGenere()
      setGenero(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }

  }

  const fetchTipoCliente = async () => {
    try {
      setLoading(true)
      const data = await tipoClienteService.getTipoCliente()
      setTipoCliente(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }

  }

  const fetchEstadoCivil = async () => {
    try {
      setLoading(true)
      const data = await estadoCivilService.getEstadoCivil()
      setEstadoCivil(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }

  }

  useEffect(() => {
    fetchCountry()
    fetchRegion()
    fetchProvincias()
    fetchComunas()
    fetchGenero()
    fetchTipoCliente()
    fetchEstadoCivil()
  }, [])

  useEffect(() => {
    try {
      var customerData = contractFull.pagador

      // Actualizar el estado mapeando las propiedades
      setPayingCustomer({
        Identifier: customerData.identifier || '',
        rut: customerData.identifier || '',
        firstName: customerData.firstName || '',
        lastName: customerData.lastName || '',
        email: customerData.email || '',
        phone: customerData.telephone || '',
        address: customerData.address || '',
        country: customerData.idCountry || '',
        region: customerData.idRegion || '',
        provincia: customerData.idProvince || '',
        comuna: customerData.idDistrito || '',
        tipoCliente: customerData.idTipoPersona || '',
        observations: customerData.observations || '',
        pymeData: customerData.pymeData || '',
        genero: customerData.idGenero || '',
        estadoCivil: customerData.idEstadoCivil || '',
        rutPyme: customerData.rutPyme || '', // No se incluye en el objeto original
        nombrePyme: customerData.nombrePyme || '', // No se incluye en el objeto original
        ocupacion: customerData.ocupacion || '',
      })

      setDireccion(customerData.address ?? '')
      setSelectedCountry(customerData.idCountry ?? '')
      setSelectedRegion(customerData.idRegion ?? '')
      setSelectedProvincia(customerData.idProvince ?? '')
      setSelectedComuna(customerData.idDistrito ?? '')
      setSelectedTipo(customerData.idTipoPersona ?? 1)
      setSelectedGenero(customerData.idGenero ?? '')
      setSelectedEstadoCivil(customerData.idEstadoCivil ?? '')
    } catch (error) {
      console.error('Error al obtener el cliente:', error)
    }


  }, [contractFull])


  useEffect(() => {
    if (contractFull && contractFull.negocios && contractFull.negocios.length > 0) {
      var negocio = contractFull.negocios[0]
      if (negocio.urlFE) {
        setAllowUpdate(false)
      }
      else if (negocio.urlFEXL) {
        setAllowUpdate(false)
      } else {
        setAllowUpdate(true)
      }
    } else {
      setAllowUpdate(true)
    }
  }, [contractFull]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: window.GOOGLE_API_KEY,
    libraries, // Cargamos la biblioteca de places
  })

  function removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  function includesIgnoreAccents(str, search) {
    return removeAccents(str).toLowerCase().includes(removeAccents(search).toLowerCase())
  }

  const handlePlaceChanged = (e) => {
    if (autocomplete) {
      const place = autocomplete.getPlace()

      // Actualiza la dirección completa
      setDireccion(place.formatted_address)
      handleChange({ target: { name: 'address', value: place.formatted_address } })


      // Extraer datos de región, provincia y comuna
      const addressComponents = place.address_components

      const regionData = addressComponents.find((comp) =>
        comp.types.includes('administrative_area_level_1')
      )
      const provinciaData = addressComponents.find((comp) =>
        comp.types.includes('administrative_area_level_2')
      )
      const comunaData = addressComponents.find((comp) =>
        comp.types.includes('locality')
      )

      if (regionData) {
        const sRegion = regiones.find((r) => r.description.includes(regionData.long_name))
        setSelectedRegion(sRegion.id)
        handleRegionChange(e, sRegion)

      }
      if (provinciaData) {
        const sProvincia = provincias.find((p) => includesIgnoreAccents(p.description, provinciaData.long_name))
        setSelectedProvincia(sProvincia.id)
        handleProvinciaChange(e, sProvincia)
      }
      if (comunaData) {
        const sComuna = comunas.find((c) => includesIgnoreAccents(c.description, comunaData.long_name))
        setSelectedComuna(sComuna.id)
        handleComunaChange(e, sComuna)
      }

    }
  }


  const handleChange = (e) => {
    const { name, value } = e.target
    setPayingCustomer(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleCountryChange = (event, newValue) => {
    const countryId = newValue ? newValue.id : ''
    setSelectedCountry(countryId)
    setPayingCustomer(prevState => ({
      ...prevState,
      country: countryId
    }))
  }

  const handleRegionChange = (event, newValue) => {
    const idRegion = newValue ? newValue.id : ''
    setSelectedRegion(idRegion)
    setPayingCustomer(prevState => ({
      ...prevState,
      region: idRegion
    }))
  }

  const handleProvinciaChange = (event, newValue) => {
    const idProvidence = newValue ? newValue.id : ''
    setSelectedProvincia(idProvidence)
    setPayingCustomer(prevState => ({
      ...prevState,
      provincia: idProvidence

    }))
  }

  const handleComunaChange = (event, newValue) => {
    const comunaId = newValue ? newValue.id : ''
    setSelectedComuna(comunaId)
    setPayingCustomer(prevState => ({
      ...prevState,
      comuna: comunaId

    }))


  }
  const handleGeneroChange = (event, newValue) => {
    const generoId = newValue ? newValue.id : ''
    setSelectedGenero(generoId)
    setPayingCustomer(prevState => ({
      ...prevState,
      genero: generoId
    }))
  }

  const handleOcupacionChange = (event, newValue) => {
    setPayingCustomer(prevState => ({
      ...prevState,
      ocupacion: newValue
    }))
  }

  const handleEstadoCivil = (event, newValue) => {
    const estadoCivilId = newValue ? newValue.id : ''
    setSelectedEstadoCivil(estadoCivilId)
    setPayingCustomer(prevState => ({
      ...prevState,
      estadoCivil: estadoCivilId
    }))
  }

  const handleTipoClienteChange = (event) => {
    const tc = Number(event.target.value) // Convertimos a número si es necesario
    setSelectedTipo(tc)

    setPayingCustomer(prevState => ({
      ...prevState,
      tipoCliente: tc, // Asegúrate de usar el nombre correcto de la propiedad en tu estado
    }))
  }



  const handlePymeRutChange = (event) => {
    const rp = event.target.value
    setRutPyme(rp)
    setPayingCustomer((prevData) => ({
      ...prevData,
      rutPyme: rp.replace(/[ .]/g, ''),

    }))
  }


  const handlePymeNomChange = (event) => {
    const np = event.target.value
    setNombrePyme(np)
    setPayingCustomer((prevData) => ({
      ...prevData,
      nombrePyme: np,

    }))
  }


  const validarCampos = (lineId) => {
    const paymentInfo = paymentData[lineId]
    const camposFaltantes = []

    if (!paymentInfo?.paymentMethod) camposFaltantes.push('Método de Pago')
    if (!paymentInfo?.firstPaymentDate) camposFaltantes.push('Fecha del Primer Pago')
    if (!paymentInfo?.numberOfInstallments) camposFaltantes.push('N° de Cuotas')

    return camposFaltantes
  }


  const checkCuotas = async () => {
    try {
      return await LobService.CheckContractData(contractFull.numContratos)
    } catch (error) {
      console.error(error)
    }
  }
  // Verificar los datos recibidos en CuotasForm

  useEffect(() => {

    const fetchServices = async () => {
      try {
        const contrato = await LobService.getContractBy(contractFull.rut, contractFull.numContratos)

        setFormData({
          contratoId: contrato.id || '',
          identifier: contrato.identifier || '',
          firstName: contrato.firstName || '',
          numContrato: contrato.numContrato || '',
          observaciones: contrato.observaciones || '',
          fechaContrato: contrato.fechaContrato ? new Date(contrato.fechaContrato) : null,

        })
        setLinesOfBusiness(contrato?.contract_Line || [])

        // Inicializar las páginas para cada línea de negocio
        const initialPages = {}
        contrato?.contract_Line?.forEach(line => {
          initialPages[line.idBusiness] = 0
        })
        setPages(initialPages)
        // Obtener los métodos de pago
        const metodos = await LobService.getMetodosPago()
        setMetodosPago(metodos)

        //seleccionar metodo de pago por defecto
        contrato?.contract_Line.forEach(line => {
          handlePaymentChange(line.idBusiness, 'paymentMethod', 6)
        })

      } catch (error) {
        console.error('Error fetching services:', error)
      }
    }
    if (contractFull?.rut && contractFull?.numContratos) {
      fetchServices()
    }
  }, [contractFull])

  // Verificar que los parámetros son correctos
  const handleChangePage = (lineId, newPage) => {
    setPages(prevPages => ({
      ...prevPages,
      [lineId]: newPage
    }))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPages(prevPages => {
      const newPages = {}
      Object.keys(prevPages).forEach(key => {
        newPages[key] = 0
      })
      return newPages
    })
  }

  const handlePaymentChange = (lineId, field, value) => {
    setPaymentData(prevState => ({
      ...prevState,
      [lineId]: {
        ...prevState[lineId],
        [field]: value
      }
    }))
  }


  // Función para obtener el nombre del método de pago por su ID
  const getPaymentMethodName = (paymentMethodId) => {
    const metodo = metodosPago.find((metodo) => metodo.id === paymentMethodId)
    return metodo ? metodo.name : 'No seleccionado'
  }
  const cancelCuotas = () => {
    setInstallments({})
    setShowCuotas(!showCuotas)
  }

  const calculateInstallments = (lineId) => {

    var lp = paymentData[lineId].laborPercentage
    if (lineId == 4 && lp < 0) {
      Swal.fire({
        title: 'Falta Porcentaje Laboral',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }
    if (lineId == 4 && (lp < 0 || lp > 100)) {
      Swal.fire({
        title: 'Porcentaje laboral fuera de rango',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }

    const camposFaltantes = validarCampos(lineId)

    if (camposFaltantes.length > 0) {
      Swal.fire({
        title: 'Campos incompletos',
        html: `Por favor, complete los siguientes campos:<br><br>${camposFaltantes.join('<br>')}`,
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }

    var paymentInfo = paymentData[lineId]
    if (!paymentInfo || !paymentInfo.firstPaymentDate || !paymentInfo.numberOfInstallments) return

    const line = linesOfBusiness.find(line => line.idBusiness === lineId)
    var totalAmount = line.contractServices.reduce((acc, service) => acc + service.amount, 0)
    const numberOfInstallments = parseInt(paymentInfo.numberOfInstallments)

    if (paymentInfo.montoRestar == null || paymentInfo.montoRestar == "" || paymentInfo.montoRestar == undefined) {
      paymentInfo.montoRestar = 0
    }
    // Calcular la cuota base
    if (contractFull.motivoContratoId && contractFull.motivoContratoId > 1) {
      var restar = paymentInfo.montoRestar ?? 0;
      var montoAnterior = contractFull.montoAnexo ?? 0;
      if (restar > montoAnterior) {
        Swal.fire({
          title: 'Atencion',
          html: `El monto a restar no puede superar el monto del servicio anterior`,
          icon: 'warning',
          confirmButtonText: 'Entendido'
        })
        return
      }

      totalAmount = totalAmount + (montoAnterior - restar)
    }

    const baseInstallment = Math.floor(totalAmount / numberOfInstallments)

    // Calcular la diferencia que se debe ajustar en la primera cuota
    const remainder = totalAmount - (baseInstallment * numberOfInstallments)

    const installmentsArray = []
    const firstDate = new Date(paymentInfo.firstPaymentDate)

    for (let i = 0; i < numberOfInstallments; i++) {
      const date = new Date(firstDate)
      date.setMonth(date.getMonth() + i)

      let amount = baseInstallment
      if (i === 0) {
        // Ajustar la primera cuota con la diferencia
        amount += 0//remainder
      }

      installmentsArray.push({
        number: i + 1,
        date: date.toISOString().split('T')[0],
        amount: amount.toFixed(0)
      })
    }

    setInstallments(prevState => ({
      ...prevState,
      [lineId]: installmentsArray
    }))

    if (cuotasData && cuotasData.length > 0) {
      var _cuotas = cuotasData
      _cuotas[0].pagoCuotas = installmentsArray
      dispatch(setCuotas(_cuotas))
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!ValidarEmail(payingCustomer.email)) {
      Swal.fire({
        title: 'Correo Incorrecto',
        html: `${payingCustomer.email} tiene formato incorrecto`,
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }
    var check = null;
    //validar rut
    if (
      !installments ||
      Object.keys(installments).length === 0 ||
      Object.keys(installments).length < linesOfBusiness.length
    ) {
      Swal.fire({
        title: 'Campos incompletos',
        html: `Por favor, calcule las cuotas antes de avanzar`,
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }

    if (!ValidarRut(payingCustomer.rut)) {
      Swal.fire({
        title: "Rut no valido",
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return;
    }


    if (linesOfBusiness.every(obj =>
      Array.isArray(obj.cuotas) && obj.cuotas.some(cuota =>
        Array.isArray(cuota.pagoCuotas) && cuota.pagoCuotas.length > 0
      )
    )) {
      var check1 = await checkCuotas()
      if (check1.continuar == false) {

        Swal.fire({
          title: "Cuotas pendientes",
          html: `${check1.message}`,
          icon: 'warning',
          confirmButtonText: 'Entendido'
        })
        return
      } else
        check = check1
    }

    // Validar que todos los campos necesarios para cada línea de negocio estén completos
    if (!showCuotas) {
      var activarTab = true;
      for (let line of linesOfBusiness) {

        const camposFaltantes = validarCampos(line.idBusiness)

        //confirma que el  contractline  en base de datos este aprobada o no exista, significa que 
        if (camposFaltantes.length > 0) {
          Swal.fire({
            title: 'Campos incompletos',
            html: `Por favor, complete los siguientes campos para ${line.lineOfBusinessName}:<br><br>${camposFaltantes.join('<br>')}`,
            icon: 'warning',
            confirmButtonText: 'Entendido'
          })
          return
        }
      }

      if (
        !installments ||
        Object.keys(installments).length === 0 ||
        Object.keys(installments).length < linesOfBusiness.length
      ) {
        Swal.fire({
          title: 'Campos incompletos',
          html: `Por favor, calcule las cuotas antes de avanzar`,
          icon: 'warning',
          confirmButtonText: 'Entendido'
        })
        return
      }
    }

    var lp = paymentData[contractFull.negocios[0].lineId].laborPercentage
    if (contractFull.negocios[0].lineId == 4 && lp < 0) {
      Swal.fire({
        title: 'Falta Porcentaje Laboral',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }
    if (contractFull.negocios[0].lineId == 4 && (lp < 0 || lp > 100)) {
      Swal.fire({
        title: 'Porcentaje laboral fuera de rango',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      })
      return
    }

    try {

      if (contractFull.pagador && contractFull.pagador.id)
        payingCustomer.id = contractFull.pagador.id

      if (contractFull.contractId)
        payingCustomer.contractId = contractFull.contractId
      // Agregar pagador
      const pagador = await customerService.createPayingCustomerService(payingCustomer)
      // Enviar los datos al servicio API

      var dataToSubmit = {}

      if (!showCuotas) {
        // cuando modifica cuotas
        dataToSubmit = {
          contract: {
            contratoId: contractFull.contractId,
            identifier: contractFull.rut.replace(/[ .]/g, ''),
            numContrato: contractFull.numContratos,
            firstName: contractFull.nombre,
            observaciones: contractFull.observaciones,
            fechaContrato: contractFull.fechaNegocio,
            HA: _TAB.interview.content,
          },
          payingCustomerId: contractFull.pagador.id,
          linesOfBusiness: contractFull.negocios.map(negocio => {
            var cuota = cuotasData.find(c => c.contractLineId === negocio.id)
            return {
              idBusiness: negocio.lineId,
              laborPercentage: paymentData[negocio.lineId].laborPercentage ?? null,
              paymentMethod: paymentData[negocio.lineId] ? paymentData[negocio.lineId].paymentMethod : cuota.metodoPagoId,
              firstPaymentDate: paymentData[negocio.lineId] ? paymentData[negocio.lineId].firstPaymentDate : cuota.fechaPrimerPago,
              numberOfInstallments: paymentData[negocio.lineId] ? paymentData[negocio.lineId].numberOfInstallments : cuota.numeroCuotas,
              montoTotal: cuota.pagoCuotas.reduce((total, pc) => total + pc.monto, 0),
              documentURl: negocio.urlS3,
              montoRestar: paymentData[negocio.lineId]?.montoRestar ?? 0,//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
              installments: installments[negocio.lineId] ? installments[negocio.lineId] : cuota.pagoCuotas.map(pc => {
                return {
                  number: pc.numeroCuota,
                  date: pc.fechaCuota,
                  amount: pc.monto,
                }
              })
            }

          })
        }
        await LobService.saveContractData(dataToSubmit)

      } else {
        if (Object.keys(installments).length === 0 && allIdsExist(contractFull, cuotasData)) {
          dispatch(setTab("4"))
          return
        }

        // cuando crea las cuotas
        dataToSubmit = {
          contract: formData,
          payingCustomerId: pagador.id, // Agregar el payingCustomerId aquí
          linesOfBusiness: linesOfBusiness.map(line => ({
            idBusiness: line.idBusiness,
            paymentMethod: paymentData[line.idBusiness]?.paymentMethod,
            firstPaymentDate: paymentData[line.idBusiness]?.firstPaymentDate,
            numberOfInstallments: paymentData[line.idBusiness]?.numberOfInstallments,
            installments: installments[line.idBusiness] || [],
            laborPercentage: paymentData[line.idBusiness].laborPercentage ?? null,
          }))
        }
        await LobService.saveContractData(dataToSubmit)
      }


      // Mostrar mensaje de éxito
      Swal.fire({
        title: 'Éxito',
        text: 'El contrato y las cuotas se han guardado correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar'
      })
      setShowCuotas(true)
      var aux = contractFull
      aux.pagador = pagador
      aux.dataToSubmit = dataToSubmit
      dispatch(setContractFull(aux))
      dispatch(setTab("4"))

    } catch (error) {

      if (error.message.includes("cuotas supera el máximo")) {
        Swal.fire({
          title: 'Se Requiere Autorización',
          text: 'El número de cuotas excede el máximo permitido, se ha enviado un correo al supervisor solicitando su aprobación',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })

        return
      }
      // Mostrar mensaje de error
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al intentar guardar el contrato. Por favor, inténtelo de nuevo.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      })
    }
  }

  if (!isLoaded) return <div>Cargando...</div>

  const allIdsExist = (full, parcial) => {
    const fullIds = full.negocios.map(negocio => negocio.id);
    return fullIds.every(id => parcial.some(obj => obj.contractLineId === id));
  }

  const handleEditAmountInstallment = (lineId, _Number, newAmount) => {
    var aux = installments[lineId]

    //obtenemos el total para verificacion posterior
    const TotalAmount = aux.reduce((sum, item) => sum + parseFloat(item.amount), 0)
    if (newAmount > TotalAmount) return;
    // actualizamos el monto, de la cuota asignada
    aux = aux.map(item => item.number === _Number ? { ...item, amount: newAmount } : item)

    //obtenemos el montoTotal hasta la cuota actualizada (incluida)
    const AmountUpTo = aux.filter(item => item.number <= _Number).reduce((sum, item) => sum + parseFloat(item.amount), 0)
    const Diff = TotalAmount - AmountUpTo
    const CuantaActualizar = aux.filter(item => item.number > _Number).length

    // Calcular la cuota base
    const newAmountPending = Math.floor(Diff / CuantaActualizar)

    // Calcular la diferencia que se debe ajustar en la primera cuota
    const colita = Diff - (newAmountPending * CuantaActualizar)

    let first = false
    // Actualizar las cuotas restantes con el nuevo monto
    aux = aux.map(item => {
      if (item.number > _Number) {
        if (!first) {
          first = true // Marcar que ya se hizo la primera actualización
          return { ...item, amount: (newAmountPending + colita).toFixed(0) }
        }
        return { ...item, amount: newAmountPending.toFixed(0) }
      }
      return item
    })

    //monto total despues de la actualizacion y correccion para verificar las modificaciones correctamente
    var totalAmount2 = aux.reduce((sum, item) => sum + parseFloat(item.amount), 0)
    if (TotalAmount == totalAmount2) {
      // guardar actualizaciones
      setInstallments(prevState => ({
        ...prevState,
        [lineId]: aux
      }))
    }

  }

  const handleEditDateInstallment = (lineId, _Number, newDate) => {
    let aux = installments[lineId]
    aux = aux.map(item => item.number === _Number ? { ...item, date: moment(newDate).format("YYYY-MM-DD") } : item)
    setInstallments(prevState => ({ ...prevState, [lineId]: aux }))
  }

  const formatCurrency = (value) => {
    if (!value) return ""
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
    }).format(value)
  }


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <Paper elevation={5} sx={{ p: 4, mt: 4 }}>
        <Alert className='mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
        <Alert className='mb-4' severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Formulario principal del contrato */}
            <Grid item sm={12}>
              <Divider sx={{ mt: 3, mb: 3 }}>DATOS DEL PAGADOR</Divider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                size="large"
                onClick={cleanCustomer}
                disabled={(!allowUpdate || bloquearAcciones)}
              >
                Limpiar
              </Button>
              <Button
                style={{ marginLeft: '24px' }}
                variant="contained"
                startIcon={<AddIcon />}
                size="large"
                onClick={fetchCustomer}
                disabled={(!allowUpdate || bloquearAcciones)}
              >
                Cargar Datos de cliente
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="rut"
                label="Rut Pagador o Pasaporte"
                name="rut"
                helperText={
                  <span style={{ color: 'red' }}>
                    (Campo obligatorio)
                  </span>
                }
                value={payingCustomer.rut.replace(/[ .]/g, '') || ""}
                onChange={handleChange}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="firstName"
                label="Nombre Cliente"
                name="firstName"
                helperText={
                  <span style={{ color: 'red' }}>
                    (Campo obligatorio)
                  </span>
                }
                //value={customerData?.properties?.firstName || ""}
                value={payingCustomer.firstName || ''}
                onChange={(e) => handleChange(e)}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="lastName"
                label="Apellido Cliente"
                name="lastName"
                helperText={
                  <span style={{ color: 'red' }}>
                    (Campo obligatorio)
                  </span>
                }
                //  value={customerData?.properties?.lastName || customer.lastName || ''}
                value={payingCustomer.lastName || ''}
                onChange={(e) => handleChange(e)}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="ocupacion"
                options={ocupaciones}
                getOptionLabel={(option) => option || ''}
                value={ocupaciones.find((oc) => oc === payingCustomer.ocupacion) || null}
                onChange={handleOcupacionChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ocupación"
                    fullWidth
                    required
                    helperText={
                      !payingCustomer.ocupacion && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                    disabled={(!allowUpdate || bloquearAcciones)}
                  />
                )}
              />



            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="email"
                label="Email"
                name="email"
                helperText={
                  <span style={{ color: 'red' }}>
                    (Campo obligatorio)
                  </span>
                }
                //value={customerData?.properties?.email || ""}
                value={payingCustomer.email || ''}
                onChange={(e) => handleChange(e)}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="phone"
                label="Telefono"
                name="phone"
                helperText={
                  <span style={{ color: 'red' }}>
                    (Campo obligatorio)
                  </span>
                }
                //value={customerData?.properties?.phone || ""}
                value={payingCustomer.phone || ''}
                onChange={(e) => handleChange(e)}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="genero"
                options={generos}
                getOptionLabel={(option) => option.description || ''}
                value={generos.find((genero) => genero.id === selectedGenero) || null}
                onChange={handleGeneroChange} // Usamos la función adaptada
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Género Cliente"
                    fullWidth
                    required
                    helperText={
                      !selectedGenero && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                    disabled={(!allowUpdate || bloquearAcciones)}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={3}>
                <Grid item sm={8}>
                  <Autocomplete
                    id="estadoCivil"
                    options={estadoCiviles}
                    getOptionLabel={(option) => option.name || ''}
                    value={estadoCiviles.find((ec) => ec.id === selectedEstadoCivil) || null}
                    onChange={handleEstadoCivil}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Estado Civil"
                        fullWidth
                        required
                        helperText={
                          !selectedEstadoCivil && (
                            <span style={{ color: 'red' }}>
                              (Campo obligatorio)
                            </span>
                          )
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading ? <CircularProgress size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        disabled={(!allowUpdate || bloquearAcciones)}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <GoogleMapsAutocomplete
                onLoad={(autocompleteInstance) => setAutocomplete(autocompleteInstance)}
                onPlaceChanged={handlePlaceChanged}
                options={{ componentRestrictions: { country: 'cl' } }}
              >
                <TextField
                  label="Dirección"
                  fullWidth
                  variant="outlined"
                  value={direccion.substring(0, 100) ?? ''}
                  onChange={(e) => setDireccion(e.target.value.substring(0, 100))}
                  placeholder="Ingresa tu dirección"
                  sx={{ mb: 3 }}
                  disabled={(!allowUpdate || bloquearAcciones)}
                />
              </GoogleMapsAutocomplete>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="country"
                options={countries}
                getOptionLabel={(option) => option.description || ''}
                value={countries.find((country) => country.id === selectedCountry) || null}
                onChange={handleCountryChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="País de Nacimiento"
                    fullWidth
                    required
                    helperText={
                      !selectedRegion && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                  />
                )}
                disabled={(!allowUpdate || bloquearAcciones)}
              />
            </Grid>

            {/* Campo de Región */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="region"
                options={regiones}
                getOptionLabel={(option) => option.description || ''}
                value={regiones.find((region) => region.id === selectedRegion) || null}
                onChange={handleRegionChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Región"
                    fullWidth
                    required
                    helperText={
                      !selectedRegion && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                    disabled={(!allowUpdate || bloquearAcciones)}
                  />
                )}
              />
            </Grid>
            {/* Campo de Provincia */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="provincia"
                options={provincias}
                getOptionLabel={(option) => option.description || ''}
                value={provincias.find((provincia) => provincia.id === selectedProvincia) || null}
                onChange={handleProvinciaChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Provincia"
                    fullWidth
                    required
                    helperText={
                      !selectedProvincia && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                    disabled={(!allowUpdate || bloquearAcciones)}
                  />
                )}
              />
            </Grid>
            {/* Campo de Comuna */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="comuna"
                options={comunas}
                getOptionLabel={(option) => option.description || ''}
                value={comunas.find((comuna) => comuna.id === selectedComuna) || null}
                onChange={handleComunaChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Comuna"
                    fullWidth
                    required
                    helperText={
                      !selectedComuna && (
                        <span style={{ color: 'red' }}>
                          (Campo obligatorio)
                        </span>
                      )
                    }
                    disabled={(!allowUpdate || bloquearAcciones)}
                  />
                )}
              />
            </Grid>

            {/* -------------------------------------------------------------------------- */}
            <Grid item xs={12} sm={6}>
              <FormControl component="fieldset" variant="standard">
                <FormLabel component="legend">Tipo Cliente</FormLabel>
                <RadioGroup value={selectedTipo} onChange={handleTipoClienteChange}>
                  {tiposCliente.map((tipo) => (
                    <FormControlLabel
                      key={tipo.id}
                      value={tipo.id}
                      control={<Radio />}
                      label={tipo.name}
                      hidden={(!allowUpdate || bloquearAcciones)}
                    />
                  ))}
                </RadioGroup>

                {(selectedTipo === 2 || (payingCustomer?.rutPyme != null && payingCustomer?.rutPyme.length > 0)) && (
                  <Grid container spacing={3}>
                    <Grid item xs={12} >
                      <TextField
                        fullWidth
                        label="Rut Pyme"
                        name="rutPyme"
                        value={payingCustomer?.rutPyme.replace(/[ .]/g, '')} //rutPyme nombrePyme
                        onChange={handlePymeRutChange}
                        disabled={(!allowUpdate || bloquearAcciones)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Nombre Pyme"
                        name="nombrePyme"
                        value={payingCustomer?.nombrePyme}
                        onChange={handlePymeNomChange}
                        disabled={(!allowUpdate || bloquearAcciones)}
                      />
                    </Grid>
                  </Grid>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                id="observations"
                label="Observaciones"
                name="observations"
                value={payingCustomer?.observations || ""}
                onChange={handleChange}
                multiline
                rows={4}
                disabled={(!allowUpdate || bloquearAcciones)}
              />

            </Grid>
          </Grid>
          <Grid item sm={12}>
            <Divider sx={{ mt: 3, mb: 3 }}>DATOS DE SERVICIOS</Divider>
          </Grid>
          {/* Mostrar todas las líneas de negocio */}
          {linesOfBusiness.map((line) => {
            const totalAmount = line.contractServices.reduce((acc, service) => acc + service.amount, 0)
            const paymentInfo = paymentData[line.idBusiness] || {}
            const maxCuota = line.contractServices.reduce((max, service) => {
              return service.maxCuotas > max ? service.maxCuotas : max
            }, 0)
            return (
              <Grid item xs={12} key={line.idBusiness} className='mt-2'>
                <Typography variant="h6">{line.lineOfBusinessName}</Typography>

                <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Servicio</TableCell>
                        <TableCell>Monto</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {line.contractServices.map(service => (
                        <TableRow key={service.idService}>
                          <TableCell>{service.serviceName}</TableCell>
                          <TableCell>{formatToCLP(service.amount)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Typography variant="subtitle1">Total: {formatToCLP(totalAmount)}</Typography>
                <Typography variant="subtitle1" hidden={line.idBusiness != 4}>Porcentaje: {line.cuotas[0]?.laborPercentage ?? ''}%</Typography>

                {/* Formulario para el cálculo de cuotas por línea */}
                {line.cuotas[0]?.pagoCuotas?.length > 0 && showCuotas ?
                  <>

                    <Button
                      className='mt-3 mb-3'
                      variant="contained"
                      size="large"
                      onClick={() => setShowCuotas(!showCuotas)}
                      disabled={(!allowUpdate || bloquearAcciones)}
                    >Recalcular Cuotas </Button>

                    <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>N° Cuota</TableCell>
                            <TableCell>Fecha</TableCell>
                            <TableCell>Monto</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {line.cuotas[0].pagoCuotas.map((cuota, index) => (
                            <TableRow key={index}>
                              <TableCell>{cuota.numeroCuota}</TableCell>
                              <TableCell>{new Date(cuota.fechaCuota).toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' })}</TableCell>
                              <TableCell>{formatToCLP(cuota.monto)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                  :
                  <>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Método de Pago</InputLabel>
                          <Select

                            label="Método de Pago"
                            value={paymentInfo.paymentMethod || 6}
                            setDefaultValue={6}
                            onChange={(e) => handlePaymentChange(line.idBusiness, 'paymentMethod', e.target.value)}
                          >
                            {metodosPago.map((metodo) => (
                              <MenuItem key={metodo.id} value={metodo.id}>
                                {metodo.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label="Fecha del Primer Pago"
                          value={paymentInfo.firstPaymentDate || null}
                          minDate={new Date()}
                          onChange={(date) => handlePaymentChange(line.idBusiness, 'firstPaymentDate', date)}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          fullWidth
                          label="N° de Cuotas"
                          type="number"
                          helperText={
                            paymentInfo.numberOfInstallments
                              ? paymentInfo.numberOfInstallments > maxCuota
                                ? <span style={{ color: 'red' }}>
                                  {`El número máximo de cuotas es ${maxCuota}`}
                                </span>
                                : paymentInfo.numberOfInstallments < 1
                                  ? <span style={{ color: 'red' }}>
                                    {'El número mínimo de cuotas es 1'}
                                  </span>
                                  : null
                              : <span style={{ color: 'red' }}>
                                {'(Campo obligatorio)'}
                              </span>
                          }
                          value={paymentInfo.numberOfInstallments || ''}
                          onChange={(e) =>
                            handlePaymentChange(
                              line.idBusiness,
                              'numberOfInstallments',
                              e.target.value
                            )
                          }
                        />
                      </Grid>
                      {contractFull.motivoContratoId && contractFull.motivoContratoId > 1 && contractFull.montoAnexo && contractFull.montoAnexo > 0 ?
                        <>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              label="Monto del servico anterior"
                              value={contractFull.montoAnexo || ''}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>

                            <TextField
                              fullWidth
                              label="Monto Pagado a Restar"
                              type="number"
                              value={contractFull.montoRestar ?? paymentInfo.montoRestar ?? contractFull.montoAnexo ?? ''}
                              onChange={(e) => {
                                let value = e.target.value;

                                // solo números
                                value = value.replace(/\D/g, '');

                                // eliminar ceros a la izquierda (pero dejar 0 si está vacío)
                                value = value.replace(/^0+(?=\d)/, '');
                                if (value === '') value = '0';

                                const numericValue = Number(value);
                                handlePaymentChange(line.idBusiness, 'montoRestar', numericValue.toString())

                                var aux = contractFull
                                aux.montoRestar = numericValue.toString();
                                setContractFull(aux)

                              }
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <Alert className='mb-4' severity="warning">Si el plan de pagos del servicios anterior esta completo Restar el total del servicio Anterior .</Alert>
                          </Grid>
                        </>
                        : null
                      }


                      <Grid item xs={12} sm={2} hidden={line.idBusiness != 4}>
                        <TextField
                          fullWidth
                          label="Porcentaje Laboral"
                          type="number"
                          value={paymentInfo.laborPercentage || ''}
                          onChange={(e) => handlePaymentChange(line.idBusiness, 'laborPercentage', e.target.value)}
                          inputProps={{ min: 0, max: 100, }}
                          error={
                            paymentInfo.laborPercentage !== '' &&
                            (paymentInfo.laborPercentage < 0 || paymentInfo.laborPercentage > 100)
                          }
                          helperText={
                            paymentInfo.laborPercentage !== '' &&
                              (paymentInfo.laborPercentage < 0 || paymentInfo.laborPercentage > 100)
                              ? 'El porcentaje debe estar entre 0 y 100'
                              : '(Campo obligatorio)'
                          }

                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Button variant="contained" size="large" onClick={() => calculateInstallments(line.idBusiness)} >
                          Calcular Cuotas
                        </Button>
                        <Button className='ms-2' variant="contained" color='warning' size="large" onClick={() => cancelCuotas()} hidden={showCuotas}>
                          Cancelar
                        </Button>
                      </Grid>
                    </Grid>

                    {/* Mostrar cuotas calculadas para esta línea */}
                    {installments[line.idBusiness] && (
                      <>
                        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                          Cuotas Calculadas {/*para {line.lineOfBusinessName*/}
                        </Typography>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>N° Cuota</TableCell>
                                <TableCell>Fecha</TableCell>
                                <TableCell>Monto</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {installments[line.idBusiness].map((installment) => (
                                <TableRow key={installment.number}>
                                  <TableCell>{installment.number}</TableCell>
                                  <TableCell>
                                    <DatePicker
                                      variant="standard"
                                      minDate={new Date()}
                                      value={installment.date ? moment(installment.date).toDate() : null}
                                      onChange={(date) => handleEditDateInstallment(line.idBusiness, installment.number, date)}
                                      renderInput={(params) => <TextField {...params} fullWidth />}
                                      size='md'
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                                      <Input
                                        id="standard-adornment-amount"
                                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                        value={installment.amount}
                                        onChange={(e) => handleEditAmountInstallment(line.idBusiness, installment.number, e.target.value.replace(/[^0-9]/g, ''))}
                                        size='md'
                                      />
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <PDFDownloadLink
                          document={
                            <InstallmentPDF
                              installments={installments[line.idBusiness]}
                              totalAmount={totalAmount}
                              lineOfBusinessName={line.lineOfBusinessName}
                              formData={formData} // Información del cliente
                              fechaSolicitud={new Date().toLocaleDateString()}
                              paymentMethodName={getPaymentMethodName(paymentInfo.paymentMethod)}
                              services={line.contractServices}
                            />
                          }
                          fileName={`cuotas_calculadas_${formData.identifier}.pdf`} // Usamos el identifier del cliente
                        >


                          <Tooltip title="Descargar Previsualización en PDF" hidden>
                            <IconButton color="error" size="large">
                              {({ loading }) =>
                                loading ? 'Generando PDF...' : 'Descargar Previsualización en PDF'
                              }
                              <PictureAsPdfIcon fontSize="inherit" />
                            </IconButton  >
                          </Tooltip>

                        </PDFDownloadLink>
                      </>


                    )}
                  </>
                }
              </Grid>
            )
          })}
          <Grid item xs={12} >
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 3 }}>


              {(allowUpdate && !bloquearAcciones) ?
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  type="submit"
                  size="large"
                >
                  Guardar y Continuar
                </Button>
                :
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<SkipNext />}
                  size="large"
                  onClick={() => dispatch(setTab("4"))} // Utilizar la función combinada
                > Continuar </Button>
              }
            </Box>

          </Grid>
        </form>
      </Paper >
    </LocalizationProvider >
  )
}

export default CuotasForm